// extracted by mini-css-extract-plugin
export default {"flex":"x7lhCo","tight":"KLvRA6","divider":"bD9keq","text":"z1_1xs","button":"vJ1Tkr","select":"BAHuXU","page":"hYp5Qq"};